export default function IconPin() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-64f566f5-927e-40cd-8616-c97e7f7c1ec6"
      data-name="Layer 2"
      viewBox="0 0 25.478 30.696"
    >
      <defs>
        <style>
          {
            ".uuid-2b4f1eaf-9e37-4df3-8a22-6ffc0dddb4d6{fill:none;stroke:var(--color-primary);stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g id="uuid-257fc936-0fc9-42fc-aa62-e0c205695e6e" data-name="Layer 1">
        <path
          d="M24.478 12.74c0 9.13-11.739 16.956-11.739 16.956S1 21.869 1 12.739C1 6.256 6.256 1 12.74 1s11.738 5.256 11.738 11.74Z"
          className="uuid-2b4f1eaf-9e37-4df3-8a22-6ffc0dddb4d6"
        />
        <path
          d="M12.74 16.652a3.913 3.913 0 1 0 0-7.826 3.913 3.913 0 0 0 0 7.826Z"
          className="uuid-2b4f1eaf-9e37-4df3-8a22-6ffc0dddb4d6"
        />
      </g>
    </svg>
  );
}
